// extracted by mini-css-extract-plugin
export default {"payingForCard":"payingForCard__1Eg24","payingForLabel":"payingForLabel__1UXNR","payingForText":"payingForText__2M-9o"};